import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const RoyalDynastyEstate = () => {
  const heroImages = [
    "/assets/img/estates/Royal Dynasty Estate.png",
    "/assets/img/estates/Royal Dynasty Estate_2.png",
  ];

  const pricing = [
    { type: "2‑Bedroom Apartment (Carcass)", price: "₦40M" },
    { type: "3‑Bedroom Apartment (Carcass)", price: "₦50M" },
    { type: "5‑Bedroom Duplex (Carcass)", price: "₦150M" },
  ];

  const highlights = [
    { icon: "fa-building", text: "Modern architecture with elegant and timeless aesthetics" },
    { icon: "fa-expand", text: "Spacious living, dining, and bedroom layouts" },
    { icon: "fa-sink", text: "Well‑planned kitchen and bathroom placements" },
    { icon: "fa-tree", text: "Private balconies with scenic views" },
    { icon: "fa-car", text: "Ample parking space" },
  ];

  const amenities = [
    { icon: "fa-shield-alt", text: "24‑hour security with CCTV" },
    { icon: "fa-fence", text: "Perimeter fencing" },
    { icon: "fa-road", text: "Paved internal roads with drainage" },
    { icon: "fa-water", text: "Constant water supply & power backup" },
    { icon: "fa-leaf", text: "Green areas & landscaping" },
    { icon: "fa-trash-can", text: "Waste management" },
  ];

  return (
    <>
      <style>{`
        .estate-page {
          animation: fadeIn 0.6s ease;
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }

        /* ========= Hero Section – Flex Layout ========= */
        .hero-section {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 4rem 2rem;
          background: linear-gradient(135deg, #f9f9f9 0%, #ffffff 100%);
          border-radius: 0 0 30px 30px;
          gap: 3rem;
          flex-wrap: wrap;
          position: relative;
          overflow: hidden;
        }
        .hero-section::before {
          content: '';
          position: absolute;
          top: -50px;
          right: -50px;
          width: 200px;
          height: 200px;
          background: #e86b24;
          opacity: 0.05;
          border-radius: 50%;
          z-index: 0;
        }
        .hero-text {
          flex: 1 1 400px;
          max-width: 550px;
          position: relative;
          z-index: 1;
        }
        .hero-text h1 {
          font-size: 2.5rem;
          font-weight: 700;
          color: #0a1a3d;
          line-height: 1.2;
          margin-bottom: 1.5rem;
        }
        .hero-text h1 span {
          color: #e86b24;
          position: relative;
        }
        .hero-text h1 span::after {
          content: '';
          position: absolute;
          bottom: -4px;
          left: 0;
          width: 60px;
          height: 3px;
          background: #e86b24;
          border-radius: 2px;
        }
        .hero-text p {
          font-size: 1.1rem;
          color: #555;
          line-height: 1.7;
        }
        .hero-image {
          flex: 1 1 400px;
          max-width: 500px;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 20px 50px rgba(0,0,0,0.1);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .hero-image:hover {
          transform: translateY(-5px);
          box-shadow: 0 25px 60px rgba(0,0,0,0.15);
        }
        .hero-image img {
          width: 100%;
          height: auto;
          display: block;
          object-fit: cover;
        }

        /* Content Sections */
        .content-section {
          max-width: 1000px;
          margin: 2rem auto;
          padding: 0 20px;
        }
        .card {
          background: #fff;
          border-radius: 16px;
          padding: 30px;
          box-shadow: 0 8px 24px rgba(0,0,0,0.04);
          margin-bottom: 2rem;
        }
        .card h2 {
          font-size: 1.8rem;
          font-weight: 700;
          color: #0a1a3d;
          margin-bottom: 1rem;
          display: inline-block;
        }
        .underline-orange {
          position: relative;
          display: inline-block;
        }
        .underline-orange::after {
          content: '';
          position: absolute;
          bottom: -4px;
          left: 0;
          width: 0;
          height: 3px;
          background: #e86b24;
          transition: width 0.3s ease;
        }
        .underline-orange:hover::after {
          width: 100%;
        }

        /* Pricing Cards */
        .price-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 20px;
          margin: 1.5rem 0;
        }
        .price-item {
          background: #f9f9f9;
          border: 2px solid transparent;
          border-radius: 14px;
          padding: 25px 15px;
          text-align: center;
          transition: transform 0.3s, box-shadow 0.3s, border-color 0.3s;
          cursor: default;
        }
        .price-item:hover {
          transform: translateY(-5px);
          box-shadow: 0 12px 30px rgba(0,0,0,0.1);
          border-color: #e86b24;
        }
        .price-item h3 {
          color: #e86b24;
          font-weight: 700;
          font-size: 1.6rem;
          margin-bottom: 0.5rem;
        }
        .price-item p {
          color: #555;
          font-size: 0.95rem;
        }

        /* Icon Cards */
        .icon-card-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 20px;
        }
        .icon-card {
          background: #f9f9f9;
          border: 2px solid transparent;
          border-radius: 14px;
          padding: 25px 20px;
          display: flex;
          align-items: flex-start;
          gap: 15px;
          transition: transform 0.3s, box-shadow 0.3s, border-color 0.3s;
          height: 100%;
          box-sizing: border-box;
        }
        .icon-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 10px 25px rgba(0,0,0,0.08);
          border-color: #e86b24;
        }
        .icon-card i {
          font-size: 1.8rem;
          color: #e86b24;
          flex-shrink: 0;
          width: 40px;
          text-align: center;
        }
        .icon-card span {
          font-size: 0.95rem;
          color: #333;
          line-height: 1.5;
        }

        /* Creative card (intro & location) */
        .creative-card {
          background: #fff;
          border-radius: 16px;
          padding: 30px;
          box-shadow: 0 8px 24px rgba(0,0,0,0.04);
          margin-bottom: 2rem;
          display: flex;
          align-items: center;
          gap: 20px;
          border-left: 5px solid #e86b24;
          transition: transform 0.3s, box-shadow 0.3s;
        }
        .creative-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 12px 30px rgba(0,0,0,0.08);
        }
        .creative-card .icon {
          font-size: 2.5rem;
          color: #e86b24;
          flex-shrink: 0;
        }
        .creative-card .details h3 {
          font-size: 1.5rem;
          font-weight: 600;
          color: #0a1a3d;
          margin-bottom: 0.5rem;
        }
        .creative-card .details p {
          color: #555;
          font-size: 0.95rem;
          line-height: 1.6;
        }

        /* Register Button */
        .register-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: #25D366;
          color: #fff;
          padding: 15px 35px;
          border-radius: 50px;
          font-weight: 700;
          font-size: 1.1rem;
          text-decoration: none;
          transition: background 0.3s, transform 0.3s, box-shadow 0.3s;
          box-shadow: 0 8px 20px rgba(37, 211, 102, 0.3);
        }
        .register-btn:hover {
          background: #1da851;
          transform: translateY(-2px);
          box-shadow: 0 12px 28px rgba(37, 211, 102, 0.4);
        }

        @media (max-width: 768px) {
          .hero-section {
            flex-direction: column-reverse;
            padding: 2rem 1rem;
            gap: 2rem;
          }
          .hero-text h1 {
            font-size: 2rem;
          }
          .creative-card {
            flex-direction: column;
            text-align: center;
          }
        }
      `}</style>

      <div className="estate-page">
        {/* Hero Section – Flex Layout */}
        <div className="hero-section">
          <div className="hero-text">
            <h1>
              <span>Royal Dynasty Estate</span><br />Apo‑Wumba, FCT Abuja
            </h1>
            <p>
              Discover the epitome of elegance and modern comfort at Royal Dynasty
              Estate, beautifully situated in the serene and fast‑developing
              community of Apo‑Wumba, right by Copa Kabana.
            </p>
          </div>
          <div className="hero-image">
            <img src="/assets/img/estates/Royal Dynasty Estate.png" alt="Royal Dynasty Estate" />
          </div>
        </div>

        <div className="content-section">
          {/* Intro */}
          <div className="creative-card">
            <div className="icon"><i className="fal fa-star"></i></div>
            <div className="details">
              <h3>Discover Your Canvas for Luxury</h3>
              <p>
                Discover the epitome of elegance and modern comfort at Royal
                Dynasty Estate, beautifully situated in the serene and
                fast‑developing community of Apo‑Wumba, right by Copa Kabana.
                Designed to cater to families, professionals, and visionary
                investors seeking a refined urban lifestyle, the estate showcases
                masterfully crafted 2‑bedroom apartments and sprawling 5‑bedroom
                duplexes.
              </p>
              <p>
                Delivered at the "carcass" stage, these properties offer a unique
                advantage: a structurally sound, high‑quality blank canvas that
                allows you to bring in your own interior design team and finish
                your home exactly to your personal taste.
              </p>
            </div>
          </div>

          {/* Pricing */}
          <div className="card">
            <h2 style={{ display: 'block', textAlign: 'center', width: '100%' }}>
              Available Properties & Pricing
            </h2>
            <div className="price-grid">
              {pricing.map((item, idx) => (
                <div className="price-item" key={idx}>
                  <h3>{item.price}</h3>
                  <p>{item.type}</p>
                </div>
              ))}
            </div>
            <p className="text-muted text-center">
              Take advantage of the carcass framework to customize your premium
              interior finishes, tiles, and fittings!
            </p>
          </div>

          {/* Property Highlights */}
          <div className="card">
            <h2><span className="underline-orange">Property Highlights</span></h2>
            <div className="icon-card-grid">
              {highlights.map((item, idx) => (
                <div className="icon-card" key={idx}>
                  <i className={`fal ${item.icon}`}></i>
                  <span>{item.text}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Estate Amenities */}
          <div className="card">
            <h2><span className="underline-orange">Estate Amenities</span></h2>
            <div className="icon-card-grid">
              {amenities.map((item, idx) => (
                <div className="icon-card" key={idx}>
                  <i className={`fal ${item.icon}`}></i>
                  <span>{item.text}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Location */}
          <div className="creative-card">
            <div className="icon"><i className="fal fa-map-marker-alt"></i></div>
            <div className="details">
              <h3>Prime Location in Apo‑Wumba</h3>
              <p>
                Directly by Copa Kabana with excellent road networks providing
                rapid access to major city destinations, business hubs, and
                premium leisure spots.
              </p>
            </div>
          </div>

          {/* Register Interest */}
          <div className="text-center" style={{ marginTop: '2rem' }}>
            <a
              href="https://wa.me/23407055558942?text=Hello%2C%20I%20am%20interested%20in%20Royal%20Dynasty%20Estate%20(Apo-Wumba)"
              target="_blank"
              rel="noopener noreferrer"
              className="register-btn"
            >
              <i className="fab fa-whatsapp me-2"></i> Register Interest via WhatsApp
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default RoyalDynastyEstate;